import React from 'react';
import { FormattedMessage } from 'react-intl';

import ContactList from '../widgets/contact-list.jsx';
import LetterTile from '../widgets/letter-tile.jsx'

import { Topic } from '../tinode/topic'
import MessagesUtil from '../tinode/messagesUtils'

import { makeImageUrl } from '../lib/blob-helpers.js';
import { IconRemoveMember } from '../icons/svg'


export default class NewTopicGroup extends React.Component {
  constructor(props) {
    super(props);

    this.fullName = React.createRef();

    this.state = {
      fullName: '', // full/formatted name
      private: '',
      description: '',
      imageUrl: null,
      tags: [],
      isChannel: false,
      newAvatar: null,
      newAvatarMime: null,
      disableCreate: true,
      members: []
    };

    this.handleFieldEdit = this.handleFieldEdit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGroupMemberAdd = this.handleGroupMemberAdd.bind(this);
    this.handleGroupMemberRemove = this.handleGroupMemberRemove.bind(this);
  }

  componentDidMount() {
    // this.fullName.current.focus();
  }

  handleFieldEdit(name, e) {
    this.setState({ [name]: e.target.value || '' });
  }

  handleSubmit(e) {
    e.preventDefault();
    const listMembers = this.state.members.map(member => Topic.getThreadId(member.topic))
    const name = this.state.fullName || 'Group'
    const id = MessagesUtil.xmppid()
    this.props.tinode.sendRequestCreateGroup(name, listMembers, id).then((resultData) => {
      const { topicId } = resultData
      this.props.handleCreateGroupSuccess(topicId)
    })
  }

  handleGroupMemberAdd(topicName) {
    window.logger('handleGroupMemberAdd', topicName)
    const members = this.state.members
    if (members.filter(topic => topic.topic === topicName).length === 0) {
      const lmember = this.props.contacts.filter(topic => topic.topic === topicName)
      if (lmember.length > 0) {
        const member = lmember[0]
        members.push(member)
        this.setState({
          members,
          disableCreate: members.length < 2,
        })
      }
    }
  }

  handleGroupMemberRemove(topicName) {
    window.logger('handleGroupMemberRemove', topicName)
    if (this.state.members.filter(topic => topic.topic === topicName).length > 0) {
      const members = this.state.members.filter((topic) => topic.topic !== topicName)
      this.setState({
        members,
        disableCreate: members.length < 2,
      })
    }
  }



  render() {
    return (
      <div className="new-topic-group-container">
        <div className="panel-form-column new-topic-group-name-container">
          <div className="group">
            <label className="small" htmlFor="new-topic-fn">
              <FormattedMessage id="label_topic_name" defaultMessage="Name"
                description="Label for editing topic name" />
            </label>
            <FormattedMessage id="topic_name_editing_placeholder" defaultMessage="Freeform name of the group"
              description="Prompt for entering topic name">{
                (placeholder) => <input
                  type="text"
                  id="new-topic-fn"
                  placeholder={placeholder}
                  ref={this.fullName}
                  value={this.state.fullName}
                  onChange={this.handleFieldEdit.bind(this, 'fullName')}
                  autoFocus
                  required
                  tabIndex={0}
                />
              }</FormattedMessage>
          </div>
        </div>
        {this.state.members.length > 0 && <div className="members-selected-container">
          {
            this.state.members.map((contact) => {
              const avatar = makeImageUrl(contact.public ? contact.public.photo : null)
              const name = contact.private && contact.private.comment ? contact.private.comment : contact.public.fn

              return (
                <div className='contact-box member-selected'>
                  <div className="avatar-box member-selected-avatar" key={contact.user}>
                    <LetterTile
                      tinode={this.props.tinode}
                      topic={contact.user}
                      avatar={avatar || true}
                      title={contact.public ? contact.public.fn : null} />
                    <div className='member-selected-remove' onClick={() => this.handleGroupMemberRemove(contact.topic)}>
                      <IconRemoveMember className='remove-icon' />
                    </div>
                  </div>
                  <div className="member-selected-name">{name}</div>
                </div>
              )
            })
          }
        </div>}
        <div className="flex-column contact-search-members">
          <ContactList
            tinode={this.props.tinode}
            contacts={this.props.contacts}
            myUserId={this.props.myUserId}
            emptyListMessage={''}
            showOnline={false}
            showUnread={false}
            showContextMenu={false}
            onTopicSelected={this.handleGroupMemberAdd} />
        </div>
        {!this.state.disableCreate && <div className="dialog-buttons">
          <button
            className='primary'
            onClick={this.handleSubmit}
          >
            <FormattedMessage id="button_create" defaultMessage="Create"
              description="Button [Create]" />
          </button>
        </div>}
      </div>
    );
  }
};
